import '@babel/polyfill';
import Vue from 'vue';
import ViewUI from 'view-design';
import './common/less/index.less';

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import WdzCommonComponent, { i18n } from 'wdz-common-components';

import App from './App.vue';
import router from './router';
import store from './store';
// import i18n from './i18n';
// import './plugins/iview';
import VueFullscreen from 'vue-fullscreen';
import * as vClickOutside from 'v-click-outside-x';

Vue.config.productionTip = false;
Vue.use(PerfectScrollbar); //滚动条
Vue.use(WdzCommonComponent, {
  systemFrame: true,
  enterpriseSelect: true,
  userHead: true,
  fileUploader: true,
  organizeSelect: true,
  departmentSelect: true,
  organizeCombotree: true,
});
Vue.use(vClickOutside);
Vue.use(VueFullscreen);
// new Vue({
//   router,
//   store,
//   i18n,
//   render: h => h(App),
// }).$mount('#app');

i18n.load('homepage', 'default').then(iviewLocale => {
  Vue.use(ViewUI, { capture: false, locale: iviewLocale });
  new Vue({
    el: '#app',
    router,
    i18n,
    store,
    render: h => h(App),
  });
});
